import { AppPageEnum } from "app/shared/enums";
import { tMatchingActionType, tMatchingSectionType } from "app/types/statement.const.type";

export class AttentionModel {
    visible!: boolean;
    message = '';
    messageHtml = '';
    buttonText = '';
    blocking = false;
    isAlert = false;
    action!: tMatchingActionType;
    section!: tMatchingSectionType;
    // skipcq: JS-0323
    data: any;
    // skipcq: JS-0323
    container?: any;
    confirmAttentionScope = AppPageEnum.Base;

    constructor(init?: Partial<AttentionModel>) {
        if (init) {
            Object.assign(this, init);
        }
    }
}